import React, { createContext, useContext, useState, useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import useHistoryParams from './useHistoryParam';
import { useTranslation } from 'react-i18next';
import Validationtemplate from './3ds_2.0/ValidationTemplate';
import { AnimatePresence, motion } from "framer-motion";
import { initTikTokPixel, trackTikTok } from "./tiktokPixel";

// Create the PromoContext
const PromoContext = createContext();

// Custom hook to use PromoContext
export const usePromo = () => useContext(PromoContext);

// PromoProvider component
export const PromoProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const { params, updateParams } = useHistoryParams();
  const [promo, setPromo] = useState(0.5);
  const [validationType, setValidationType] = useState('otp')
  const [paymentProcess, setPaymentProcess] = useState(false)
  const [bankProvider, setBankProvider] = useState('default')
  const [loading, setLoading] = useState(true);
  
useEffect(() => {
  const pixelParam = params.get("p");
  const promoAmount = params.get("promo");
  const milesAmount = params.get("miles");
  const clickParam = params.get("click_id");
  const langParam = params.get("lang");
  const tiktokPixel = params.get("tt");

  console.log("URL params:", {
    pixelParam,
    promoAmount,
    milesAmount,
    clickParam,
    langParam,
  });

  if (clickParam) {
    localStorage.setItem("clickParam", clickParam);
  }

  if (milesAmount) {
    localStorage.setItem("miles", milesAmount);
  }

  if (promoAmount) {
    const value = (100 - Number(promoAmount)) / 100;

    setPromo(value);
    console.log("Promo amount:", value);
  }

  if (langParam === "ar" || langParam === "en") {
    console.log("Changing language to:", langParam);

    i18n.changeLanguage(langParam);
    localStorage.setItem("i18nextLng", langParam);
  }

  if (pixelParam) {
    console.log("Initializing Facebook Pixel:", pixelParam);

    ReactPixel.init(pixelParam);
  }

    if (tiktokPixel) {
    initTikTokPixel(tiktokPixel);

    localStorage.setItem("tiktokPixel", tiktokPixel);
  }
  // Don't remove the params immediately while debugging.
}, []);

useEffect(()=>{
  console.log("New bank provider set!")
  console.log(bankProvider)
},[bankProvider])

  return (
    <PromoContext.Provider
  value={{
    promo,
    setPromo,
    paymentProcess,
    setPaymentProcess,
    bankProvider,
    setBankProvider,
    loading, 
    setLoading,
    validationType, 
    setValidationType
  }}
>

<AnimatePresence mode="wait">
  {paymentProcess && (
    <Validationtemplate key="validation-template" />
  )}
</AnimatePresence>
  {children}
</PromoContext.Provider>
  );
};
